/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerComplianceBlockingStatus
 */
export interface FreelancerComplianceBlockingStatus {
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerComplianceBlockingStatus
     */
    blocked: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FreelancerComplianceBlockingStatus
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof FreelancerComplianceBlockingStatus
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerComplianceBlockingStatus
     */
    authorAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerComplianceBlockingStatus
     */
    authorFullName: string;
}

/**
 * Check if a given object implements the FreelancerComplianceBlockingStatus interface.
 */
export function instanceOfFreelancerComplianceBlockingStatus(value: object): value is FreelancerComplianceBlockingStatus {
    if (!('blocked' in value) || value['blocked'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('authorAccountId' in value) || value['authorAccountId'] === undefined) return false;
    if (!('authorFullName' in value) || value['authorFullName'] === undefined) return false;
    return true;
}

export function FreelancerComplianceBlockingStatusFromJSON(json: any): FreelancerComplianceBlockingStatus {
    return FreelancerComplianceBlockingStatusFromJSONTyped(json, false);
}

export function FreelancerComplianceBlockingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerComplianceBlockingStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'blocked': json['blocked'],
        'date': (new Date(json['date'])),
        'reason': json['reason'],
        'authorAccountId': json['authorAccountId'],
        'authorFullName': json['authorFullName'],
    };
}

export function FreelancerComplianceBlockingStatusToJSON(value?: FreelancerComplianceBlockingStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'blocked': value['blocked'],
        'date': ((value['date']).toISOString()),
        'reason': value['reason'],
        'authorAccountId': value['authorAccountId'],
        'authorFullName': value['authorFullName'],
    };
}

